import { render, staticRenderFns } from "./AdminGameBuddyManager.vue?vue&type=template&id=7ed10128&scoped=true"
import script from "./AdminGameBuddyManager.vue?vue&type=script&lang=js"
export * from "./AdminGameBuddyManager.vue?vue&type=script&lang=js"
import style0 from "./AdminGameBuddyManager.vue?vue&type=style&index=0&id=7ed10128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed10128",
  null
  
)

export default component.exports